<template>
  <div class="balance-page">

    <!-- ═══ 顶部操作栏 ═══ -->
    <section class="module-topbar">
      <button class="btn-download" @click="$emit('download')">
        <svg viewBox="0 0 20 20" fill="currentColor" style="width:16px;height:16px">
          <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd"/>
        </svg>
        下载客户端
      </button>
    </section>

    <!-- ═══ 功能特性 ═══ -->
    <section class="balance-intro">
      <div class="balance-intro-features">
        <div class="balance-feat">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:20px;height:20px">
            <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10"/>
          </svg>
          <span>物料衡算</span>
        </div>
        <div class="balance-feat">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:20px;height:20px">
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
          </svg>
          <span>能量衡算</span>
        </div>
        <div class="balance-feat">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:20px;height:20px">
            <circle cx="12" cy="12" r="3"/>
            <path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4"/>
          </svg>
          <span>全流程计算</span>
        </div>
        <div class="balance-feat">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:20px;height:20px">
            <polygon points="12 2 2 7 12 12 22 7 12 2"/>
            <polyline points="2 17 12 22 22 17"/>
            <polyline points="2 12 12 17 22 12"/>
          </svg>
          <span>自定义工段</span>
        </div>
        <div class="balance-feat">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:20px;height:20px">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
          </svg>
          <span>Word 报告输出</span>
        </div>
        <div class="balance-feat">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:20px;height:20px">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
          </svg>
          <span>自动拓扑排序</span>
        </div>
      </div>
      <div class="balance-stats">
        <div class="balance-stat">
          <span class="balance-stat-num">100%</span>
          <span class="balance-stat-label">自动化率</span>
        </div>
        <div class="balance-stat-div"></div>
        <div class="balance-stat">
          <span class="balance-stat-num">5+</span>
          <span class="balance-stat-label">衡算模块</span>
        </div>
        <div class="balance-stat-div"></div>
        <div class="balance-stat">
          <span class="balance-stat-num">0</span>
          <span class="balance-stat-label">数据上传</span>
        </div>
        <div class="balance-stat-div"></div>
        <div class="balance-stat">
          <span class="balance-stat-num">DOCX</span>
          <span class="balance-stat-label">专业报告</span>
        </div>
      </div>
    </section>

    <!-- ═══ 报告预览区 ═══ -->
    <section class="balance-pdf-section">
      <div class="balance-pdf-head">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:16px;height:16px">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
        </svg>
        报告预览
      </div>

      <!-- Tab 切换 -->
      <div class="balance-tabs">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          class="balance-tab-btn"
          :class="{ active: activeTab === tab.id }"
          @click="switchTab(tab.id)"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:14px;height:14px" v-html="tab.icon"></svg>
          {{ tab.label }}
        </button>
      </div>

      <!-- 预览容器 -->
      <div class="balance-pdf-wrap">
        <!-- PDF 预览 -->
        <vue-pdf-app
          v-if="activeTab !== 'segment' && currentTabData.src"
          :pdf="currentTabData.src"
          theme="dark"
          :page-scale="'page-fit'"
          class="balance-pdf-viewer"
        />
        <!-- Excel 表格预览 -->
        <div v-if="activeTab === 'segment'" class="balance-excel-wrap">
          <div v-if="excelLoading" class="balance-excel-loading">
            <div class="balance-excel-spinner"></div>
            <span>正在加载 Excel 数据...</span>
          </div>
          <div v-else-if="excelError" class="balance-pdf-empty">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" style="width:56px;height:56px;opacity:.15">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
              <line x1="16" y1="13" x2="8" y2="13"/>
              <line x1="16" y1="17" x2="8" y2="17"/>
            </svg>
            <p class="balance-pdf-empty-text">加载失败</p>
            <p class="balance-pdf-empty-sub">{{ excelError }}</p>
          </div>
          <div v-else-if="!excelData" class="balance-pdf-empty">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" style="width:56px;height:56px;opacity:.15">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
              <line x1="16" y1="13" x2="8" y2="13"/>
              <line x1="16" y1="17" x2="8" y2="17"/>
            </svg>
            <p class="balance-pdf-empty-text">暂无报告</p>
            <p class="balance-pdf-empty-sub">工段物料衡算报告待生成</p>
          </div>
          <div v-else class="balance-excel-content" v-html="excelHtml"></div>
        </div>
        <!-- 无报告 -->
        <div v-if="!currentTabData.src" class="balance-pdf-empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" style="width:56px;height:56px;opacity:.15">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10 9 9 9 8 9"/>
          </svg>
          <p class="balance-pdf-empty-text">暂无报告</p>
          <p class="balance-pdf-empty-sub">请先进行衡算操作</p>
        </div>
      </div>
    </section>

  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import VuePdfApp from 'vue3-pdf-app'
import 'vue3-pdf-app/dist/icons/main.css'
import * as XLSX from 'xlsx'

defineEmits(['download'])

const tabs = [
  {
    id: 'energy',
    label: '能量衡算',
    icon: '<path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>',
    src: '/pdfs/能量衡算示例.pdf',
  },
  {
    id: 'material',
    label: '物料衡算',
    icon: '<path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10"/>',
    src: '/pdfs/物料衡算示例.pdf',
  },
  {
    id: 'segment',
    label: '工段物料衡算',
    icon: '<polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/>',
    src: '/pdfs/工段物料衡算.xlsx',
  },
]

const activeTab = ref('energy')

const currentTabData = computed(() => tabs.find(t => t.id === activeTab.value))

// Excel 加载状态
const excelLoading = ref(false)
const excelError = ref(null)
const excelData = ref(null)

const excelHtml = computed(() => {
  if (!excelData.value) return ''
  return renderTable(excelData.value)
})

function renderTable(workbook) {
  const sheetNames = workbook.SheetNames
  if (!sheetNames.length) return ''

  const firstSheet = workbook.Sheets[sheetNames[0]]

  const html = XLSX.utils.sheet_to_html(firstSheet, {
    id: 'excel-table',
    display: false,
  })

  const sheetName = sheetNames[0].replace(/</g, '&lt;').replace(/>/g, '&gt;')
  return `<div class="excel-sheet-name">${sheetName}</div><div class="excel-table-wrap">${html}</div>`
}

async function loadExcel() {
  excelLoading.value = true
  excelError.value = null
  excelData.value = null
  try {
    const res = await fetch(currentTabData.value.src)
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    const ab = await res.arrayBuffer()
    const workbook = XLSX.read(ab, { type: 'array', cellStyles: true })
    excelData.value = workbook
  } catch (e) {
    excelError.value = e.message || '加载 Excel 文件失败'
  } finally {
    excelLoading.value = false
  }
}

watch(activeTab, (tab) => {
  if (tab === 'segment') {
    loadExcel()
  }
})

function switchTab(id) {
  activeTab.value = id
}
</script>

<style scoped>
/* ═══ Page ═══ */
.balance-page {
  display: flex;
  flex-direction: column;
  padding: 0 0 40px;
}

/* ═══ 顶部操作栏 ═══ */
.module-topbar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 40px;
  border-bottom: 1px solid #e8eaed;
  background: linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%);
}

.btn-download {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 20px;
  border-radius: 8px;
  background: #4285f4;
  color: #fff;
  font-size: 13.5px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  animation: heartbeat 2.5s ease-in-out infinite;
}

.btn-download:hover {
  background: #3367d6;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(66,133,244,.3);
}

.btn-download:active {
  transform: translateY(0);
}

@keyframes heartbeat {
  0%, 100% { box-shadow: 0 0 0 0 rgba(66,133,244,.45); }
  50%       { box-shadow: 0 0 0 10px rgba(66,133,244,0); }
}

/* ═══ 功能特性 ═══ */
.balance-intro {
  padding: 28px 40px;
  border-bottom: 1px solid #e8eaed;
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
}
.balance-intro-features {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 12px; font-weight: 700; color: #4285f4;
  background: #e8f0fe; padding: 4px 12px; border-radius: 20px;
  margin-bottom: 10px;
}
.badge-dot {
  width: 6px; height: 6px; background: #4285f4; border-radius: 50%;
}
.balance-intro-features {
  display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 24px;
}
.balance-feat {
  display: flex; align-items: center; gap: 7px;
  padding: 7px 14px; background: #fff;
  border: 1px solid #dadce0; border-radius: 8px;
  font-size: 13px; font-weight: 600; color: #5f6368;
  transition: border-color .15s, box-shadow .15s;
}
.balance-feat:hover { border-color: #4285f4; box-shadow: 0 2px 8px rgba(66,133,244,.1); }
.balance-feat svg { color: #4285f4; flex-shrink: 0; }

/* Stats */
.balance-stats {
  display: flex; align-items: center; gap: 0;
  background: #fff; border: 1px solid #dadce0;
  border-radius: 12px; padding: 14px 28px;
  width: fit-content;
}
.balance-stat {
  display: flex; flex-direction: column; align-items: center;
  padding: 0 28px;
}
.balance-stat-num {
  font-size: 20px; font-weight: 800; color: #202124;
}
.balance-stat-label {
  font-size: 11px; color: #9aa0a6; font-weight: 500; margin-top: 2px;
}
.balance-stat-div {
  width: 1px; height: 32px; background: #e8eaed;
}

/* ═══ 报告预览区 ═══ */
.balance-pdf-section {
  padding: 20px 40px 0;
}
.balance-pdf-head {
  display: flex; align-items: center; gap: 8px;
  font-size: 13px; font-weight: 700; color: #202124;
  margin-bottom: 10px;
}
.balance-pdf-head svg { color: #4285f4; }

/* Tab 切换 */
.balance-tabs {
  display: flex; gap: 8px; margin-bottom: 12px;
}
.balance-tab-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 16px;
  border: 1.5px solid #dadce0;
  border-radius: 8px;
  background: #fff;
  color: #5f6368;
  font-size: 13px; font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: all .15s;
}
.balance-tab-btn:hover {
  border-color: #4285f4;
  color: #4285f4;
  background: #f0f4ff;
}
.balance-tab-btn.active {
  border-color: #4285f4;
  background: #4285f4;
  color: #fff;
}
.balance-tab-btn svg { flex-shrink: 0; }

/* 预览容器 */
.balance-pdf-wrap {
  border: 1px solid #dadce0; border-radius: 12px;
  overflow: hidden;
  height: calc(100vh - 460px);
  min-height: 460px;
  position: relative;
  background: #f8f9fa;
}
.balance-pdf-viewer {
  width: 100%;
  height: 100%;
}
.balance-iframe-viewer {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
.balance-pdf-empty {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  height: 100%; gap: 8px; background: #f8f9fa;
}
.balance-pdf-empty-text {
  font-size: 15px; font-weight: 700; color: #bdc1c6; margin: 0;
}
.balance-pdf-empty-sub {
  font-size: 12px; color: #dadce0; margin: 0;
}

/* Excel 表格预览 */
.balance-excel-wrap {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f9fa;
}
.balance-excel-loading {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  height: 100%; gap: 12px; color: #80868b; font-size: 13px;
}
.balance-excel-spinner {
  width: 28px; height: 28px;
  border: 3px solid #e8eaed;
  border-top-color: #4285f4;
  border-radius: 50%;
  animation: balance-spin .7s linear infinite;
}
@keyframes balance-spin {
  to { transform: rotate(360deg); }
}
.balance-excel-content {
  padding: 16px;
}
.balance-excel-sheet-name {
  font-size: 13px; font-weight: 700; color: #5f6368;
  margin-bottom: 10px; padding: 0 2px;
}

/* ═══ Responsive ═══ */
@media (max-width: 768px) {
  .balance-intro { padding: 20px 16px; }
  .balance-intro-features { gap: 6px; }
  .balance-feat { font-size: 12px; padding: 6px 10px; }
  .balance-stats { padding: 12px 16px; }
  .balance-stat { padding: 0 16px; }
  .balance-stat-num { font-size: 16px; }
  .balance-pdf-section { padding: 16px 16px 0; }
  .balance-tabs { gap: 6px; }
  .balance-tab-btn { font-size: 12px; padding: 6px 12px; }
  .balance-pdf-wrap { height: 400px; min-height: 400px; }
}
</style>

<style>
/* v-html 渲染的 Excel 表格样式（非 scoped，必须全局才能生效） */
.balance-excel-content .excel-table-wrap {
  overflow: auto;
  border-radius: 8px;
  border: 1px solid #dadce0;
  background: #fff;
}
.balance-excel-content .excel-table-wrap table {
  border-collapse: collapse;
  font-size: 12px;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Noto Sans SC', sans-serif;
  white-space: nowrap;
}
.balance-excel-content .excel-table-wrap td,
.balance-excel-content .excel-table-wrap th {
  border: 1px solid #e0e0e0;
  padding: 5px 8px;
  min-width: 60px;
  vertical-align: middle;
}
.balance-excel-content .excel-table-wrap th {
  background: #f1f3f4;
  font-weight: 700;
  color: #202124;
  text-align: center;
}
.balance-excel-content .excel-table-wrap tr:first-child td {
  background: #f1f3f4;
  font-weight: 700;
  color: #202124;
  text-align: center;
}
.balance-excel-content .excel-sheet-name {
  font-size: 13px; font-weight: 700; color: #5f6368;
  margin-bottom: 10px; padding: 0 2px;
}
</style>
